__turbopack_context__.v({
  "className": "courier_prime_4973a641-module__2SQhHG__className",
});
